// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_MultiSet from "../Data.MultiSet/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_OrderedMultiSet from "../Data.OrderedMultiSet/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Restaumatic_Cart_ProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic_Menu_Menu from "../Restaumatic.Menu.Menu/index.js";
import * as Restaumatic_Menu_Query from "../Restaumatic.Menu.Query/index.js";
import * as Restaumatic_Menu_Types_Id from "../Restaumatic.Menu.Types.Id/index.js";
import * as Restaumatic_Menu_Types_SplitPizzaSettings from "../Restaumatic.Menu.Types.SplitPizzaSettings/index.js";
import * as Restaumatic_Menu_V2_CartToOrder from "../Restaumatic.Menu.V2.CartToOrder/index.js";
import * as Restaumatic_Menu_V2_MenuCatalogueQuery from "../Restaumatic.Menu.V2.MenuCatalogueQuery/index.js";
var sideDishPrice = function (v) {
    return Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)((function () {
        var $67 = Data_Newtype.unwrap();
        return function ($68) {
            return (function (v1) {
                return v1.price;
            })($67($68));
        };
    })())(Restaumatic_Menu_Query.findSideDish(v.sideId)(v.dishId));
};
var pizzaBaseAndToppingsPrice = function (size) {
    return function (def) {
        var toppingPrice = function (id) {
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.findTopping(id))(function (topping) {
                return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(Data_Maybe.fromMaybe(Data_Numeric.zero(Data_Money_Rounded.additiveMoney))(Data_Map_Internal.lookup(Restaumatic_Menu_Types_Id.ordPizzaSize)(size)((Data_Newtype.unwrap()(topping)).priceBySize)));
            });
        };
        var freeToppingsCount = function (basePizza) {
            return (Data_Newtype.unwrap()(basePizza)).freeToppings;
        };
        var dropFreeToppings = function (basePizza) {
            var $69 = Data_Array.drop((Data_Newtype.unwrap()(basePizza)).freeToppings);
            var $70 = Data_Array.sort(Data_Money_Rounded.ordMoney);
            return function ($71) {
                return $69(Data_Array.reverse($70($71)));
            };
        };
        if (def instanceof Restaumatic_Cart_ProductKey.StandardPizza) {
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.findPizza(def.value0))(function (pizza) {
                return Restaumatic_Menu_Query.findPizzaPrice(pizza)(size);
            });
        };
        if (def instanceof Restaumatic_Cart_ProductKey.CustomPizza) {
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.askMenu)(function (v) {
                return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.findPizza(def.value0.basePizzaId))(function (basePizza) {
                    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.findPizzaPrice(basePizza)(size))(function (basePrice) {
                        var baseToppings = Data_OrderedMultiSet.toMultiSet(Restaumatic_Menu_Types_Id.ordToppingId)((Data_Newtype.unwrap()(basePizza)).toppings);
                        var extraToppings = Data_MultiSet.difference(Restaumatic_Menu_Types_Id.ordToppingId)(def.value0.toppings)(baseToppings);
                        var removedToppings = Data_MultiSet.difference(Restaumatic_Menu_Types_Id.ordToppingId)(baseToppings)(def.value0.toppings);
                        var removedToppingsPriceQuery = Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Money_Rounded.additiveMoney))(Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Menu_Query.applicativeMenuQuery)(toppingPrice)(Data_MultiSet.elems(removedToppings)));
                        return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)((function () {
                            var $72 = Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Money_Rounded.additiveMoney);
                            var $73 = dropFreeToppings(basePizza);
                            return function ($74) {
                                return $72($73($74));
                            };
                        })())(Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Menu_Query.applicativeMenuQuery)(toppingPrice)(Data_MultiSet.elems(extraToppings))))(function (extraToppingsPrice) {
                            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)((function () {
                                if (v.toppingPriceCalculator instanceof Restaumatic_Menu_Menu.AddedToppingsCalculator) {
                                    return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(extraToppingsPrice);
                                };
                                if (v.toppingPriceCalculator instanceof Restaumatic_Menu_Menu.ToppingDifferenceCalculator) {
                                    var $18 = freeToppingsCount(basePizza) > 0;
                                    if ($18) {
                                        return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(extraToppingsPrice);
                                    };
                                    return Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(function (price) {
                                        return Data_Numeric.sub(Data_Money_Rounded.additiveMoney)(extraToppingsPrice)(price);
                                    })(removedToppingsPriceQuery);
                                };
                                if (v.toppingPriceCalculator instanceof Restaumatic_Menu_Menu.ToppingDiffWithClampCalculator) {
                                    return Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(function (price) {
                                        return Data_Ord.max(Data_Money_Rounded.ordMoney)(Data_Numeric.zero(Data_Money_Rounded.additiveMoney))(Data_Numeric.sub(Data_Money_Rounded.additiveMoney)(extraToppingsPrice)(price));
                                    })(removedToppingsPriceQuery);
                                };
                                throw new Error("Failed pattern match at Restaumatic.Cart.Pricing (line 112, column 9 - line 119, column 92): " + [ v.toppingPriceCalculator.constructor.name ]);
                            })())(function (policyExtraPrice) {
                                return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(Data_Numeric.add(Data_Money_Rounded.additiveMoney)(basePrice)(policyExtraPrice));
                            });
                        });
                    });
                });
            });
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.Pricing (line 90, column 3 - line 121, column 42): " + [ def.constructor.name ]);
    };
};
var combineSplitPizzaPrices = function (prices) {
    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.askMenu)(function (v) {
        var basePrice = (function () {
            if (v.splitPizzaSettings.basePrice instanceof Restaumatic_Menu_Types_SplitPizzaSettings.MostExpensive) {
                return Data_Maybe.fromMaybe(Data_Numeric.zero(Data_Money_Rounded.additiveMoney))(Data_Foldable.maximum(Data_Money_Rounded.ordMoney)(Data_Foldable.foldableArray)(prices));
            };
            if (v.splitPizzaSettings.basePrice instanceof Restaumatic_Menu_Types_SplitPizzaSettings.Average) {
                return Data_Money_Rounded.avgAndRound(Data_Foldable.foldableArray)(prices);
            };
            throw new Error("Failed pattern match at Restaumatic.Cart.Pricing (line 83, column 7 - line 85, column 44): " + [ v.splitPizzaSettings.basePrice.constructor.name ]);
        })();
        return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(Data_Numeric.add(Data_Money_Rounded.additiveMoney)(basePrice)((function () {
            var $25 = Data_Array.length(prices) > 1;
            if ($25) {
                return v.splitPizzaSettings.extraCharge;
            };
            return Data_Numeric.zero(Data_Money_Rounded.additiveMoney);
        })()));
    });
};
var productPriceSplitPizza = function (v) {
    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Menu_Query.applicativeMenuQuery)(pizzaBaseAndToppingsPrice(v.size))(v.parts))(function (basePrices) {
        return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(combineSplitPizzaPrices(basePrices))(function (basePrice) {
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.findPan(v.panType))(function (pan) {
                return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.findPanPrice(pan)(v.size))(function (panPrice) {
                    return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(Data_Numeric.add(Data_Money_Rounded.additiveMoney)(basePrice)(panPrice));
                });
            });
        });
    });
};
var productPricePizza = function (v) {
    return productPriceSplitPizza({
        parts: [ v.def ],
        size: v.size,
        panType: v.panType
    });
};
var productPrice = function (v) {
    var success = function (price) {
        return {
            price: new Data_Maybe.Just(price),
            errors: Data_Maybe.Nothing.value
        };
    };
    return function (v1) {
        if (v1 instanceof Restaumatic_Cart_ProductKey.Pizza) {
            return Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(success)(productPricePizza(v1.value0));
        };
        if (v1 instanceof Restaumatic_Cart_ProductKey.Dish) {
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(Data_Newtype.unwrap())(Restaumatic_Menu_Query.findMainDish(v1.value0.id)))(function (dish) {
                return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Money_Rounded.additiveMoney))(Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Menu_Query.applicativeMenuQuery)(sideDishPrice)(Data_Array.fromFoldable(Data_Set.foldableSet)(v1.value0.sides))))(function (sidesPrice) {
                    return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(success(Data_Numeric.add(Data_Money_Rounded.additiveMoney)(dish.price)(sidesPrice)));
                });
            });
        };
        if (v1 instanceof Restaumatic_Cart_ProductKey.Drink) {
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.findDrink(v1.value0.id))(function (drink) {
                return Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(success)(Restaumatic_Menu_Query.findDrinkPrice(drink)(v1.value0.size));
            });
        };
        if (v1 instanceof Restaumatic_Cart_ProductKey.SplitPizza) {
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Menu_Query.applicativeMenuQuery)(pizzaBaseAndToppingsPrice(v1.value0.size))(v1.value0.parts))(function (basePrices) {
                return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(combineSplitPizzaPrices(basePrices))(function (basePrice) {
                    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.findPan(v1.value0.panType))(function (pan) {
                        return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.findPanPrice(pan)(v1.value0.size))(function (panPrice) {
                            return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(success(Data_Numeric.add(Data_Money_Rounded.additiveMoney)(basePrice)(panPrice)));
                        });
                    });
                });
            });
        };
        if (v1 instanceof Restaumatic_Cart_ProductKey.CustomProduct) {
            return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(success(v1.value0.price));
        };
        if (v1 instanceof Restaumatic_Cart_ProductKey.MenuProduct) {
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_V2_MenuCatalogueQuery.askMenuCatalogue)(function (menu) {
                var v2 = Restaumatic_Menu_V2_CartToOrder.runCartToOrder(Restaumatic_Menu_V2_CartToOrder.cartProductToOrderItems(menu)(v.locale)(v.schedules)(v1.value0)(v.params)(Data_Map_Internal.empty));
                if (v2 instanceof Data_Either.Right) {
                    return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)({
                        price: new Data_Maybe.Just(v2.value0.value0.unitPrice),
                        errors: new Data_Maybe.Just(new Data_Either.Right(v2.value0.value1))
                    });
                };
                if (v2 instanceof Data_Either.Left) {
                    return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)({
                        price: Data_Maybe.Nothing.value,
                        errors: new Data_Maybe.Just(new Data_Either.Left(v2.value0))
                    });
                };
                throw new Error("Failed pattern match at Restaumatic.Cart.Pricing (line 54, column 7 - line 56, column 75): " + [ v2.constructor.name ]);
            });
        };
        if (v1 instanceof Restaumatic_Cart_ProductKey.MenuCombo) {
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_V2_MenuCatalogueQuery.askMenuCatalogue)(function (menu) {
                var v2 = Restaumatic_Menu_V2_CartToOrder.runCartToOrder(Restaumatic_Menu_V2_CartToOrder.cartComboToOrderItems(menu)(v.locale)(v.schedules)(v1.value0)(v.params));
                if (v2 instanceof Data_Either.Right) {
                    return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)({
                        price: new Data_Maybe.Just(Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Money_Rounded.additiveMoney)(Data_Functor.map(Data_Functor.functorArray)(function (v3) {
                            return v3.unitPrice;
                        })(v2.value0.value0))),
                        errors: new Data_Maybe.Just(new Data_Either.Right(v2.value0.value1))
                    });
                };
                if (v2 instanceof Data_Either.Left) {
                    return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)({
                        price: Data_Maybe.Nothing.value,
                        errors: new Data_Maybe.Just(new Data_Either.Left(v2.value0))
                    });
                };
                throw new Error("Failed pattern match at Restaumatic.Cart.Pricing (line 60, column 7 - line 62, column 75): " + [ v2.constructor.name ]);
            });
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.Pricing (line 29, column 3 - line 62, column 75): " + [ v1.constructor.name ]);
    };
};
export {
    productPrice,
    productPricePizza,
    productPriceSplitPizza
};
//# sourceMappingURL=index.js.map
